import Vue from 'vue'
import Router from 'vue-router'
import VueMeta from 'vue-meta'

// components
import Home from '@/components/Home'
import Single from '@/components/Single'
import Nearby from '@/components/Nearby'
import Mine from '@/components/Mine'
import User from '@/components/User'
import PostLogin from '@/components/PostLogin'

Vue.use(Router)
Vue.use(VueMeta)

const router = new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'Home',
      component: Home
    },
    {
      path: '/nearby',
      name: 'Nearby',
      component: Nearby
    },
    {
      path: '/mine',
      name: 'Mine',
      component: Mine
    },
    {
      path: '/user/:id/:username',
      name: 'User',
      component: User
    },
    {
      path: '/id/:id',
      name: 'Single',
      component: Single
    },
    {
      path: '/post-login',
      name: 'PostLogin',
      component: PostLogin
    }
    // {
    //   path: '/add',
    //   name: 'AddOld',
    //   component: Add
    // }
  ]
})

export default router
